import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {ActivitySearchEnginePanelComponent} from './activity-search-engine-panel/activity-search-engine-panel.component';
import {SearchEngineModule} from 'shared/search-engine';
import {UiModule} from 'shared/search-engine';
import {
    ActivitySearchEngineDialogComponent
} from '@modules/activities/core/activities-search-engine/activity-search-engine-panel/activity-search-engine-dialog/activity-search-engine-dialog.component';
import {ActivitiesSharedModule} from '@modules/activities/core/activities-shared.module';
import { EducationalLevelFilterSelectorOfConceptsListComponent } from './filter-selector/educational-level-filter-selector/educational-level-filter-selector-of-concepts-list.component';
import {GenericFilterSelectorComponent} from '@modules/activities/core/activities-search-engine/filter-selector/generic-filter-selector/generic-filter-selector.component';
import {ConceptFilterSelectorComponent} from '@modules/activities/core/activities-search-engine/filter-selector/concept-filter-selector/concept-filter-selector.component';
import { ChapterFilterSelectorComponent } from './filter-selector/chapter-filter-selector/chapter-filter-selector.component';
import { LessonsSearchViewerComponent } from './lessons-search-viewer/lessons-search-viewer.component';
import { LessonHorizontalViewerComponent } from './lesson-horizontal-viewer/lesson-horizontal-viewer.component';

@NgModule({
    declarations: [
        ActivitySearchEnginePanelComponent,
        ActivitySearchEngineDialogComponent,
        GenericFilterSelectorComponent,
        ConceptFilterSelectorComponent,
        EducationalLevelFilterSelectorOfConceptsListComponent,
        ChapterFilterSelectorComponent,
        LessonsSearchViewerComponent,
        LessonHorizontalViewerComponent
    ],
    imports: [
        CommonModule,
        SearchEngineModule,
        UiModule,
        ActivitiesSharedModule,
        MatProgressSpinnerModule
    ],
    exports: [
        ActivitySearchEnginePanelComponent,
    ]
})
export class ActivitiesSearchEngineModule {

}
